import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import {
  FormInput,
  Margin,
  Text,
  FormListItem,
  Drawer,
  Form,
  Panel,
  Button,
} from 'shared/components'
import { observer } from 'mobx-react'
import { profile } from 'routes/route.map'

import * as styles from './styles'

const UserPersonalFormComponent = ({
  form,
  onSubmit,
  appConfig,
  isLoading,
  getOptionLabel,
  getOptionValue,
  loadJurisdictions,
}) => {
  const history = useHistory()

  const handlePersonalInfoClick = () => {
    // Check if mobile (phones breakpoint: 767px)
    const isMobile = window.innerWidth <= 767

    if (isMobile) {
      // Mobile: Navigate to new page
      history.push(profile.personalInfo())
    } else {
      // Desktop/Tablet: Open drawer
      appConfig.toggleDrawer('personalInfo')
    }
  }

  return (
    <>
      <FormListItem
        title="Personal information"
        description="Update your personal information"
        onClick={handlePersonalInfoClick}
      />
      <Drawer
        isActive={appConfig.drawerState === 'personalInfo'}
        hideDrawer={() => appConfig.toggleDrawer('')}
      >
        {appConfig.drawerState === 'personalInfo' && (
          <Panel
            as={Form}
            form={form}
            onSubmit={onSubmit}
            css={styles.formWrapper}
          >
            <>
              <div>
                <Margin
                  as={Text}
                  size={18}
                  bold
                  bottom={5}
                  css={styles.title}
                >
                  Personal information
                </Margin>
                <Margin tb={1} css={styles.row}>
                  <Text as="label" size={11}>
                    E-mail
                  </Text>
                  <FormInput
                    name="email"
                    placeholder="E-mail"
                    css={styles.control}
                  />
                </Margin>
                <Margin tb={1} css={styles.row}>
                  <Text as="label" size={11}>
                    Nickname
                  </Text>
                  <FormInput
                    name="nickName"
                    placeholder="Nickname"
                    css={styles.control}
                  />
                </Margin>
                <Margin tb={1} css={styles.splitRow}>
                  <div css={styles.flexGrow}>
                    <Text as="label" size={11}>
                      First Name
                    </Text>
                    <FormInput
                      name="firstName"
                      placeholder="First Name"
                      css={styles.control}
                    />
                  </div>
                  <div css={styles.flexGrow}>
                    <Text as="label" size={11}>
                      Last Name
                    </Text>
                    <FormInput
                      name="lastName"
                      placeholder="Last Name"
                      css={styles.control}
                    />
                  </div>
                </Margin>
                <Margin tb={1} css={styles.splitRow}>
                  <div css={styles.flexGrow}>
                    <Text as="label" size={11}>
                      Country
                    </Text>
                    <FormInput
                      oldInput
                      cacheOptions
                      defaultOptions
                      getOptionLabel={getOptionLabel}
                      getOptionValue={getOptionValue}
                      type="async-select"
                      name="country"
                      placeholder="Select country"
                      loadOptions={loadJurisdictions}
                      bordered
                    />
                  </div>
                  <div css={styles.flexGrow}>
                    <Text as="label" size={11}>
                      Postal Code/ZIP Code
                    </Text>
                    <FormInput
                      name="zip"
                      placeholder="Postal or ZIP code"
                    />
                  </div>
                </Margin>
                <Margin tb={1} css={styles.splitRow}>
                  <div css={styles.flexGrow}>
                    <Text as="label" size={11}>
                      State/Province/Region
                    </Text>
                    <FormInput
                      name="state"
                      placeholder="State, province or region"
                    />
                  </div>
                  <div css={styles.flexGrow}>
                    <Text as="label" size={11}>
                      City/Town
                    </Text>
                    <FormInput name="city" placeholder="City or town" />
                  </div>
                </Margin>
                <Margin tb={1} css={styles.row}>
                  <Text as="label" size={11}>
                    Address Line 1
                  </Text>
                  <FormInput
                    name="address1"
                    placeholder="Street address, P.O. box"
                  />
                </Margin>
                <Margin tb={1} css={styles.row}>
                  <Text as="label" size={11}>
                    Address Line 2
                  </Text>
                  <FormInput
                    name="address2"
                    placeholder="Apartment, suite, unit, building, floor"
                  />
                </Margin>
                <Margin bottom={2} top={1}>
                  <Button
                    type="submit"
                    medium
                    css={{ width: '100%', height: '40px' }}
                    disabled={isLoading}
                    loading={isLoading}
                  >
                    Save changes
                  </Button>
                </Margin>
              </div>
            </>
          </Panel>
        )}
      </Drawer>
    </>
  )
}

UserPersonalFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmit: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  loadJurisdictions: PropTypes.func.isRequired,
  appConfig: PropTypes.shape(),
  isLoading: PropTypes.bool,
}

export default observer(UserPersonalFormComponent)
